/* istanbul ignore file */
/* eslint-disable max-classes-per-file */
// This is a hack to get react-bootstrap 0.33.1 working with react 18
// see https://stackoverflow.com/questions/72306064/is-there-any-way-to-fix-errors-caused-by-bootstrap-when-upgrading-to-react-18
// TODO: please delete this file and usages of the component when upgrading react-bootstrap

import React, { cloneElement, PropsWithChildren } from "react";

// we will get those deps from react-bootstrap
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'warn... Remove this comment to see the full error message
// eslint-disable-next-line import/no-extraneous-dependencies
import warning from "warning";
// we will get those deps from react-bootstrap
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'dom-... Remove this comment to see the full error message
// eslint-disable-next-line import/no-extraneous-dependencies
import contains from "dom-helpers/query/contains";

import { Overlay } from "react-bootstrap";

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction(...funcs: $TSFixMe[]) {
  return funcs
    .filter((f) => f != null)
    .reduce((acc, f) => {
      if (typeof f !== "function") {
        throw new Error(
          "Invalid Argument Type, must only provide functions, undefined, or null.",
        );
      }

      if (acc === null) {
        return f;
      }

      return function chainedFunction(this: $TSFixMe, ...args: $TSFixMe[]) {
        acc.apply(this, args);
        f.apply(this, args);
      };
    }, null);
}

/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one: $TSFixMe, of: $TSFixMe) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

type triggerType = "click" | "hover" | "focus";

/*
(ts-migrate) TODO: Migrate the remaining prop types
...Overlay.propTypes
*/
type OwnProps = {
  trigger?: triggerType | triggerType[];
  delay?: number;
  delayShow?: number;
  delayHide?: number;
  defaultOverlayShown?: boolean;
  overlay: React.ReactNode;
  onBlur?: $TSFixMeFunction;
  onClick?: $TSFixMeFunction;
  onFocus?: $TSFixMeFunction;
  onMouseOut?: $TSFixMeFunction;
  onMouseOver?: $TSFixMeFunction;
  target?: $TSFixMe; // TODO: PropTypes.oneOf([null])
  onHide?: $TSFixMe; // TODO: PropTypes.oneOf([null])
  show?: $TSFixMe; // TODO: PropTypes.oneOf([null])
  placement?: "top" | "bottom" | "left" | "right";
};

const defaultProps: Partial<OwnProps> = {
  defaultOverlayShown: false,
  trigger: ["hover", "focus"],
};

type State = $TSFixMe;

type Props = OwnProps & typeof defaultProps;

class CustomOverlayTrigger extends React.Component<
  PropsWithChildren<Props>,
  State
> {
  static defaultProps = defaultProps;

  handleMouseOut: $TSFixMe;

  handleMouseOver: $TSFixMe;

  hoverHideDelay: $TSFixMe;

  hoverShowDelay: $TSFixMe;

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);

    this.handleToggle = this.handleToggle.bind(this);
    this.handleDelayedShow = this.handleDelayedShow.bind(this);
    this.handleDelayedHide = this.handleDelayedHide.bind(this);
    this.handleHide = this.handleHide.bind(this);

    this.handleMouseOver = (e: $TSFixMe) =>
      this.handleMouseOverOut(this.handleDelayedShow, e, "fromElement");
    this.handleMouseOut = (e: $TSFixMe) =>
      this.handleMouseOverOut(this.handleDelayedHide, e, "toElement");

    this.state = {
      show: props.defaultOverlayShown,
    };
  }

  handleDelayedHide() {
    if (this.hoverShowDelay != null) {
      clearTimeout(this.hoverShowDelay);
      this.hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this.hoverHideDelay != null) {
      return;
    }

    const delay =
      this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this.hoverHideDelay = setTimeout(() => {
      this.hoverHideDelay = null;
      this.hide();
    }, delay);
  }

  handleDelayedShow() {
    if (this.hoverHideDelay != null) {
      clearTimeout(this.hoverHideDelay);
      this.hoverHideDelay = null;
      return;
    }

    if (this.state.show || this.hoverShowDelay != null) {
      return;
    }

    const delay =
      this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this.hoverShowDelay = setTimeout(() => {
      this.hoverShowDelay = null;
      this.show();
    }, delay);
  }

  handleHide() {
    this.hide();
  }

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.
  handleMouseOverOut(handler: $TSFixMe, e: $TSFixMe, relatedNative: $TSFixMe) {
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !contains(target, related)) {
      handler(e);
    }
  }

  handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  }

  hide() {
    this.setState({ show: false });
  }

  makeOverlay(overlay: $TSFixMe, props: $TSFixMe) {
    return (
      <Overlay
        {...props}
        show={this.state.show}
        onHide={this.handleHide}
        target={this}
      >
        {overlay}
      </Overlay>
    );
  }

  show() {
    this.setState({ show: true });
  }

  render() {
    const {
      trigger,
      overlay,
      children,
      onBlur,
      onClick,
      onFocus,
      onMouseOut,
      onMouseOver,
      ...props
    } = this.props;

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    const child = React.Children.only(children);
    // @ts-expect-error TS(2339) Decided to expect this for now, since component is copied from bootstrap. To don't get unexpected errors.
    const childProps = child.props;
    const triggerProps = {};

    if (this.state.show) {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      triggerProps["aria-describedby"] = (overlay as $TSFixMe).props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.
    (triggerProps as $TSFixMe).onClick = createChainedFunction(
      childProps.onClick,
      onClick,
    );

    if (isOneOf("click", trigger)) {
      (triggerProps as $TSFixMe).onClick = createChainedFunction(
        (triggerProps as $TSFixMe).onClick,
        this.handleToggle,
      );
    }

    if (isOneOf("hover", trigger)) {
      warning(
        !(trigger === "hover"),
        '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' +
          "visibility of the overlay to just mouse users. Consider also " +
          'including the `"focus"` trigger so that touch and keyboard only ' +
          "users can see the overlay as well.",
      );

      (triggerProps as $TSFixMe).onMouseOver = createChainedFunction(
        childProps.onMouseOver,
        onMouseOver,
        this.handleMouseOver,
      );
      (triggerProps as $TSFixMe).onMouseOut = createChainedFunction(
        childProps.onMouseOut,
        onMouseOut,
        this.handleMouseOut,
      );
    }

    if (isOneOf("focus", trigger)) {
      (triggerProps as $TSFixMe).onFocus = createChainedFunction(
        childProps.onFocus,
        onFocus,
        this.handleDelayedShow,
      );
      (triggerProps as $TSFixMe).onBlur = createChainedFunction(
        childProps.onBlur,
        onBlur,
        this.handleDelayedHide,
      );
    }

    return (
      <>
        {/* @ts-expect-error TS(2339) Decided to expect this for now, since component is copied from bootstrap. To don't get unexpected errors. */}
        {cloneElement(child, triggerProps)}
        {this.makeOverlay(overlay, props)}
      </>
    );
  }
}

export default CustomOverlayTrigger;
